import { n as e } from "../../mode_constants-tb7TL85q.js";
import { findParentMode as t, getOppositeMode as n, getRootContrast as r } from "../mode-island/utils.js";
//#region directives/mode_directive/mode.js
var i = e, a = { inverted: "invert" }, o = {
	name: "dt-mode-directive",
	install(e) {
		let o = /* @__PURE__ */ new WeakMap();
		e.directive("dt-mode", {
			mounted(e, t) {
				if (t.value === !1) return;
				let n = c(e, s(t.arg));
				o.set(e, n);
			},
			updated(e, t) {
				let n = o.get(e), r = t.value !== t.oldValue, i = s(t.arg), a = i !== n?.arg;
				if (!r && !a || (u(n), l(e), o.delete(e), t.value === !1)) return;
				let d = c(e, i);
				o.set(e, d);
			},
			unmounted(e) {
				u(o.get(e)), l(e), o.delete(e);
			}
		});
		function s(e) {
			return e ? i.includes(e) ? e : a[e] ? (console.warn(`[DtModeDirective] Invalid mode "${e}". Did you mean "${a[e]}"? Falling back to "${a[e]}".`), a[e]) : (console.warn(`[DtModeDirective] Invalid mode "${e}". Valid modes: ${i.join(", ")}. Falling back to "invert".`), "invert") : "invert";
		}
		function c(e, i) {
			let a = {
				arg: i,
				contrastObserver: null,
				modeObserver: null
			};
			if (e.setAttribute("data-dt-contrast", r()), a.contrastObserver = new MutationObserver(() => {
				e.setAttribute("data-dt-contrast", r());
			}), a.contrastObserver.observe(document.documentElement, {
				attributes: !0,
				attributeFilter: ["data-dt-contrast"]
			}), i === "light" || i === "dark") e.setAttribute("data-dt-mode", i);
			else {
				let r = t(e);
				e.setAttribute("data-dt-mode", n(r));
				let i = {
					attributes: !0,
					attributeFilter: ["data-dt-mode"],
					subtree: !1
				};
				a.modeObserver = new MutationObserver(() => {
					let r = t(e);
					e.setAttribute("data-dt-mode", n(r));
				}), a.modeObserver.observe(document.documentElement, i);
				let o = e.parentElement;
				for (; o && o !== document.documentElement;) a.modeObserver.observe(o, i), o = o.parentElement;
			}
			return a;
		}
		function l(e) {
			e.removeAttribute("data-dt-mode"), e.removeAttribute("data-dt-contrast");
		}
		function u(e) {
			e && (e.contrastObserver && (e.contrastObserver.disconnect(), e.contrastObserver = null), e.modeObserver && (e.modeObserver.disconnect(), e.modeObserver = null));
		}
	}
};
//#endregion
export { o as DtModeDirective, o as default };

//# sourceMappingURL=mode.js.map